export default __webpack_public_path__ + "static/media/headline-minting-howto.06b6dd21.svg";